import * as React from 'react';

/**
 * A StyleableCheckbox has an empty span with classname "to-style" directly next to the checkbox <input>, and within the
 * same <label> element. This means that you are able to:
 *  * Hide the checkbox
 *  * Style the "input + .to-style" and "input:checked + .to-style" span to look like whatever you want (e.g. using
 *    background images).
 *  * Clicking the .to-style span will trigger the underlying checkbox to get checked or unchecked. This is due to it
 *    being within the same <label> element.
 *
 * Alternatively, if you don't do any of these things, it will still work as per a normal checkbox with a label that
 * can be clicked.
 */
export class StyleableCheckbox extends React.Component<StyleableCheckboxProps, {}> {

	render():JSX.Element {
		return <div className={this.props.className + ' style-checkbox'}>
			<label>
				<input
					type="checkbox"
					checked={this.props.defaultChecked}
					onChange={this.props.onChange}
					className={this.props.className}
					/>
				<span className="to-style" />
				<span className="label">{this.props.label}</span>
			</label>
		</div>
	}
}

export interface StyleableCheckboxProps {
	defaultChecked?:boolean;
	onChange?:(event:React.FormEvent<{}>) => void;
	className?:string;
	name?:string;
	value?:string;
	label?:string;
}



// WEBPACK FOOTER //
// ./src/react-components/StyleableCheckbox.tsx